import { TextStyles } from '../../types';

export const globalCss = {
  body: {
    bg: 'surface-page',
  },
  a: {
    color: 'text-interactive',
    fontWeight: 'link',
    textDecoration: 'underline',
    _hover: {
      textDecoration: 'underline',
    },
  },
  h1: {
    textStyle: TextStyles.H1,
    color: 'text-emphasis',
  },
  h2: {
    textStyle: TextStyles.H2,
    color: 'text-emphasis',
  },
  h3: {
    textStyle: TextStyles.H3,
    color: 'text-emphasis',
  },
  h4: {
    textStyle: TextStyles.H4,
    color: 'text-emphasis',
  },
  h5: {
    textStyle: TextStyles.H5,
    color: 'text-emphasis',
  },
  h6: {
    textStyle: TextStyles.H6,
    color: 'text-emphasis',
  },
  "[id^='chakra-toast-manager-']:empty": {
    visibility: 'hidden',
  },
};
